import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "gfu-box-actions" }
const _hoisted_2 = { class: "gfu-box-actions__item" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  class: "_ml-1",
  "data-qa": "create-order-btn:Back"
}
const _hoisted_5 = ["action"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["name", "value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_terms_of_service_checkbox_field = _resolveComponent("terms-of-service-checkbox-field")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_terms_of_service_checkbox_field, {
      modelValue: _ctx.model.termsAccepted,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model.termsAccepted) = $event)),
      name: "model.termsAccepted"
    }, null, 8 /* PROPS */, ["modelValue"]),
    ($props.requireAcceptDigitalDelivery)
      ? (_openBlock(), _createBlock(_component_checkbox_field, {
          key: 0,
          modelValue: _ctx.digitalDeliveryAccepted,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.digitalDeliveryAccepted) = $event)),
          condensed: true,
          "display-name": "Digital delivery agreement",
          name: "model.digitalDeliveryAccepted",
          "data-qa": "digital-delivery-agreement"
        }, {
          default: _withCtx(() => [
            _cache[7] || (_cache[7] = _createElementVNode("em", null, "*", -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString(_ctx.Resources.Checkout.CheckboxDigitalDeliveryAgreementMessage), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($options.isBackButtonVisible)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "gfu-link gfu-link--accent",
              href: $props.backAction,
              onClick: _cache[2] || (_cache[2] = $event => ($options.onBackButtonClick($event, $props.backAction)))
            }, [
              _createVNode(_component_base_icon, {
                name: "chevron-left",
                class: "_fl _lhb"
              }),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Resources.Checkout.CheckoutGoBackLink), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_3))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("form", {
        class: "gfu-box-actions__item _ml-a",
        action: $props.formAction,
        method: "post",
        onSubmit: _cache[6] || (_cache[6] = (...args) => ($options.onSubmit && $options.onSubmit(...args)))
      }, [
        _createElementVNode("input", {
          type: "hidden",
          name: "orderCode",
          value: $props.orderCode
        }, null, 8 /* PROPS */, _hoisted_6),
        _createElementVNode("input", {
          type: "hidden",
          name: _ctx.antiForgeryTokenKey,
          value: $props.antiForgeryToken
        }, null, 8 /* PROPS */, _hoisted_7),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.paymentToken) = $event)),
          type: "hidden",
          name: "paymentToken"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.paymentToken]
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.digitalDeliveryAccepted) = $event)),
          type: "hidden",
          name: "digitalDeliveryAccepted"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.digitalDeliveryAccepted]
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.paymentMethod) = $event)),
          type: "hidden",
          name: "paymentMethod"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.paymentMethod]
        ]),
        _createVNode(_component_tooltip, {
          enabled: !$props.isValid,
          text: $props.validationMessage
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_button, {
              theme: "accent",
              class: "gfu-btn--block",
              type: "submit",
              enabled: $options.isSubmitButtonEnabled,
              "data-qa": "create-order-btn:Submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.CheckoutSubmitOrderButton), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["enabled"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["enabled", "text"])
      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_5)
    ])
  ]))
}